import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';
import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '../../../routes';

const useStyles = makeStyles(theme => ({
  root: {
    width: `calc(100% - ${theme.spacing(4)})`,
    height: `calc(100vh - ${theme.spacing(11.5)})`,
    borderRadius: '.5rem',
    border: '1px solid #276ef1',
    margin: theme.spacing(2),
    overflowY: 'auto',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  infoIcon: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    color: '#276ef1',
  },
  arrowIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
}));

const MoveToPurchaseAnnouncement = () => {
  const classes = useStyles();
  const { get } = useQuery();
  const accountId = get('accountId');
  const purchasePageUrl = `${process.env.REACT_APP_PURCHASE_PAGE_URL}?accountId=${accountId}`;
  return (
    <Paper
      id="move-to-purchase-announcement"
      className={classes.root}
    >
      <Box
        id="announcement-container"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        width="60%"
      >
        <Box id="warning-icon">
          <InfoIcon className={classes.infoIcon} />
        </Box>
        <Box id="announcement-title" paddingY={1}>
          <Typography
            variant="h3"
            textOverflow="wrap"
            width="100%"
            fontWeight={700}
          >
            <FormattedMessage id="to.purchase.page.title" />
          </Typography>
        </Box>
        <Box id="announcement-message" paddingY={1}>
          <Typography variant="body1" textOverflow="wrap" width="100%" textAlign="center" fontWeight={400}>
            <FormattedMessage
              id="to.purchase.page.desc"
              values={{
                newPage: (
                  <Button
                    variant="text"
                    color="primary"
                    href={purchasePageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    purchase.katalon.com
                  </Button>
                ),
              }}
            />
          </Typography>
        </Box>
        <Box id="announcement-action-button" paddingY={1}>
          <Button
            variant="contained"
            color="primary"
            href={purchasePageUrl}
            sx={theme => ({
              padding: theme.spacing(1.5, 5),
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="to.purchase.page.btn" />
            <ArrowForwardIcon className={classes.arrowIcon} />
          </Button>
        </Box>
        <Box id="contact-support" paddingY={1}>
          <Typography
            variant="body2"
            textOverflow="wrap"
            width="100%"
            color="#6b7280"
            fontWeight={400}
          >
            <FormattedMessage
              id="contact.sale"
              values={{
                email: (
                  <a href="mailto:support@katalon.com">support@katalon.com</a>
                ),
              }}
            />
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default MoveToPurchaseAnnouncement;
